import { disableBodyScroll, enableBodyScroll } from '~js/utils/dom';
import { drawerStoreLocater } from './drawer-store-locater';

const deliveryDrawer = {
  selectors: {
    overlay: '.js-delivery-overlay',
    deliveryDrawer: '.js-delivery-drawer',
    closeDrawer: '.js-close-delivery-drawer',
  },

  el: {},

  qs(selector, parent = document) {
    return parent.querySelector(selector);
  },

  qsAll(selector, parent = document) {
    return Array.from(parent.querySelectorAll(selector));
  },

  initializeElements() {
    const { selectors: s, qs } = this;
    this.el.overlay = qs(s.overlay);
    this.el.deliveryDrawer = qs(s.deliveryDrawer);

    if (!this.el.deliveryDrawer) return;

    this.el.closeDrawer = qs(s.closeDrawer, this.el.deliveryDrawer);
  },

  initializeEvents() {
    this.initializeElements();
    this.el?.closeDrawer?.addEventListener('click', () => {
      this.closeDeliveryOverlay();
    });

    this.el?.deliveryDrawer?.addEventListener('click', (event) => {
      event.stopPropagation();
    });

    this.el?.overlay?.addEventListener('click', () => {
      this.closeDeliveryOverlay();
    });

    drawerStoreLocater.init(this.el.deliveryDrawer);
  },

  openDeliveryOverlay() {
    disableBodyScroll();
    if (this.el.overlay) {
      this.el.overlay.classList.add('js-open-delivery-overlay');
    }
    if (this.el.deliveryDrawer) {
      this.el.deliveryDrawer.classList.add('js-open-delivery-overlay');
    }
  },

  closeDeliveryOverlay() {
    enableBodyScroll();
    if (this.el.overlay) {
      this.el.overlay.classList.remove('js-open-delivery-overlay');
    }
    if (this.el.deliveryDrawer) {
      this.el.deliveryDrawer.classList.remove('js-open-delivery-overlay');
    }
  },
};

export { deliveryDrawer };
